import onAllApiRespond from './onAllApiRespond'

export default onAllApiRespond
